 // window.onload = function() {
 //      var productRecently = document.querySelector(".product-recommendations.recently-tryon-pdp");

 //      // Check if any elements with the class .product-recommendations are found
 //      if (productRecently.length > 0) {
 //          productRecently.forEach(function(productRecentlyView) {
 //              var tryonButtonRecent = productRecentlyView.querySelector(".tryonButton2");
 //              var trendingBadgeRecent = productRecentlyView.querySelector("span.badge.trending-item");

 //              console.log(tryonButtonRecent, trendingBadgeRecent); // Check if both elements are found

 //              if (tryonButtonRecent && trendingBadgeRecent) {
 //                  console.log("Executing the code to hide .tryonButton2");
 //                  tryonButtonRecent.style.display = "block"; // Hide tryonButton2
 //                  trendingBadgeRecent.style.display = "none"; // Ensure the badge is visible
 //              }
 //          });
 //      } else {
 //          console.log("No .product-recommendations element found.");
 //      }
 //  };

/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof(recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
          }

        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
